namespace SPA {
	export namespace Realtor2 {
		export namespace New {

			export class ObjectCommon extends Guide.GuideContent {

				private m_Form: ui.Form.Form;
				private m_FeatureAll: string | undefined;

				public constructor(private m_Object: IObjectCommon, private m_Obj: Realtor2.NewObject) {
					super();

					this.m_FeatureAll = undefined;
					this.m_Form = new ui.Form.Form(
						{
							action: '',
							method: 'POST',
							notSwitchable: true,
							submit: () => {
								return;
							}
						}
					);
				}

				public build(root: ui.base.BaseHTMLElement): void {
					this.m_Form.empty();
					this.m_Form.remove();
					this.m_Form.clear();

					// #region Objektart
					const row1 = new ui.base.BaseHTMLElement('div')
						.addClass('col-xs-12')
						.appendTo(
							new ui.base.BaseHTMLElement('div')
								.addClass('row')
								.appendTo(root)
						);
					const row2 = new ui.base.BaseHTMLElement('div')
						.addClass('row')
						.appendTo(root);
					const row3 = new ui.base.BaseHTMLElement('div')
						.addClass('row')
						.appendTo(root);
					this.buildObjektart(row1, row2, row3);
					// #endregion Objektart

					// #region Objektdetails
					this.buildDetails(row2, row3);
					// #endregion  Objektdetails

					// // #region ObjektAusstattung
					// this.buildDetails( row3 );
					// // #endregion  ObjektAusstattung

					// #region heating
					this.buildHeating(
						new ui.base.BaseHTMLElement('div')
							.addClass('row')
							.appendTo(root)
					);
					// #endregion heating

					// #region Bemerkung
					this.buildAnnotation(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12')
							.appendTo(
								new ui.base.BaseHTMLElement('div')
									.addClass('row')
									.appendTo(root)
							)
					);
					// #endregion Bemerkung
				}

				protected buildNavigation(nav: ui.base.BaseHTMLElement): void {
					new ui.base.Button(
						$('<i class="fas fa-arrow-circle-left"></i> <span>Zurück</span>'),
						{
							context: 'primary',
							on:
								{
									click: () => {
										if (this.m_Panel) {
											this.m_Panel.MovePrev();
										}
									}
								}
						}
					).rebuild(nav);

					new ui.base.Button(
						$('<span>Weiter</span> <i class="fas fa-arrow-circle-right"></i>'),
						{
							context: 'primary',
							on:
								{
									click: () => {
										if (this.m_Panel) {
											if (this.m_Obj.checkForm(this.m_Form)) {
												this.m_Panel.MoveNext();
											}
										}
									}
								}
						}
					).rebuild(nav);
				}

				private buildObjektart(
					_root: ui.base.BaseHTMLElement,
					details: ui.base.BaseHTMLElement,
					features: ui.base.BaseHTMLElement
				): void {
					new ui.base.BaseHTMLElement('h4')
						.addClass('text-muted')
						.text('Objektart')
						.appendTo(_root);

					const type = new ui.Form.RadioGroup(
						{
							name: 'object.type.type',
							classes: ['iwv-req'],
							control: true,
							inline: 3,
							required: true,
							radioButtons: [
								{
									value: 'EFH',
									title: 'Einfamilienhaus'
								},
								{
									value: 'ZFH',
									title: 'Zweifamilienhaus'
								},
								{
									value: 'DHH',
									title: 'Doppelhaushälfte'
								},
								{
									value: 'REH',
									title: 'Reihenendhaus'
								},
								{
									value: 'RMH',
									title: 'Reihenmittelhaus'
								},
								{
									value: 'MFH',
									title: 'Mehrfamilienhaus'
								}
							],
							value: this.m_Object.type ? this.m_Object.type.type : null,
							on:
								{
									change: () => {
										// Reset overall features
										this.m_FeatureAll = undefined;

										switch (type.val()) {
											case 'EFH':
												this.m_Object.type =
													{
														type: 'EFH',
														cellar: 0,
														floor: null,
														roof: 'full',
														features:
															{
																overall: 3,
																additional: 3,
																ceiling_stair: 3,
																exterior_wall: 3,
																roof: 3,
																floor: 3,
																heating: 3,
																indoor_wall_door: 3,
																window_door_out: 3,
																sanitary: 3
															}
													};
												break;
											case 'ZFH':
												this.m_Object.type =
													{
														type: 'ZFH',
														cellar: null,
														floor: null,
														roof: 'full',
														features:
															{
																overall: 3,
																additional: 3,
																ceiling_stair: 3,
																exterior_wall: 3,
																roof: 3,
																floor: 3,
																heating: 3,
																indoor_wall_door: 3,
																window_door_out: 3,
																sanitary: 3
															}
													};
												break;
											case 'REH':
												this.m_Object.type =
													{
														type: 'REH',
														cellar: null,
														floor: null,
														roof: 'full',
														features:
															{
																overall: 3,
																additional: 3,
																ceiling_stair: 3,
																exterior_wall: 3,
																roof: 3,
																floor: 3,
																heating: 3,
																indoor_wall_door: 3,
																window_door_out: 3,
																sanitary: 3
															}
													};
												break;
											case 'RMH':
												this.m_Object.type =
													{
														type: 'RMH',
														cellar: null,
														floor: null,
														roof: 'full',
														features:
															{
																overall: 3,
																additional: 3,
																ceiling_stair: 3,
																exterior_wall: 3,
																roof: 3,
																floor: 3,
																heating: 3,
																indoor_wall_door: 3,
																window_door_out: 3,
																sanitary: 3
															}
													};
												break;
											case 'DHH':
												this.m_Object.type =
													{
														type: 'DHH',
														cellar: null,
														floor: null,
														roof: 'full',
														features:
															{
																overall: 3,
																additional: 3,
																ceiling_stair: 3,
																exterior_wall: 3,
																roof: 3,
																floor: 3,
																heating: 3,
																indoor_wall_door: 3,
																window_door_out: 3,
																sanitary: 3
															}
													};
												break;
											case 'MFH':
												this.m_Object.type =
													{
														type: 'MFH',
														span: '1',
														units: '-_6',
														features:
															{
																overall: 3,
																additional: 3,
																ceiling_stair: 3,
																exterior_wall: 3,
																roof: 3,
																floor: 3,
																heating: 3,
																indoor_wall_door: 3,
																window_door_out: 3,
																sanitary: 3
															}
													};
												break;
											case 'ETW':
												this.m_Object.type =
													{
														type: 'ETW',
														features:
															{
																overall: 4
															}
													};
												break;

											default:
												this.m_Object.type = null;
												break;
										}

										this.buildDetails(details.empty(), features);
									}
								}
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12')
							.appendTo(
								new ui.base.BaseHTMLElement('div')
									.addClass('form-group clearfix')
									.appendTo(_root)
							),
						this.m_Form,
						type
					);
				}

				private buildAnnotation(_root: ui.base.BaseHTMLElement): void {
					new ui.base.BaseHTMLElement('h4')
						.addClass('text-muted')
						.text('Bemerkung zum Objekt')
						.appendTo(_root);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12')
							.appendTo(
								new ui.base.BaseHTMLElement('div')
									.addClass('form-group clearfix')
									.appendTo(_root)
							),
						this.m_Form,
						new ui.Form.TextArea(
							{
								name: 'object.annotation',
								text: this.m_Object.annotation,
								attr:
									{
										style: 'resize: vertical'
									},
								rows: 5
							}
						)
					);
				}

				private buildHeating(_root: ui.base.BaseHTMLElement): void // ? _root = div.row
				{
					const col = new ui.base.BaseHTMLElement('div')
						.addClass('col-xs-12')
						.appendTo(_root);

					new ui.base.BaseHTMLElement('h4')
						.addClass('text-muted')
						.text('Heizung und Heizausstattung')
						.appendTo(col);

					const fg = new ui.base.BaseHTMLElement('div').addClass('form-group clearfix').appendTo(col);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12 col-md-3')
							.appendTo(fg),
						this.m_Form,
						new ui.Form.CheckboxGroup(
							{
								control: true,
								value:
									[
										this.m_Object.heating.type.central ? 'object.heating.type.central' : '',
										this.m_Object.heating.type.per_floor ? 'object.heating.type.per_floor' : '',
										this.m_Object.heating.type.per_unit ? 'object.heating.type.per_unit' : ''
									],
								name: 'object.heating.type',
								checkboxes:
									[
										{
											title: 'Zentralheizung',
											name: 'central',
											descriptor:
												{
													on: {change: () => this.m_Object.heating.type.central = !this.m_Object.heating.type.central}
												}
										},
										{
											title: 'Dezentral je Etage',
											name: 'per_floor',
											descriptor:
												{
													on: {change: () => this.m_Object.heating.type.per_floor = !this.m_Object.heating.type.per_floor}
												}
										},
										{
											title: 'Dezentral je Wohneinheit',
											name: 'per_unit',
											descriptor:
												{
													on: {change: () => this.m_Object.heating.type.per_unit = !this.m_Object.heating.type.per_unit}
												}
										}
									]
							}
						)
					);

					const h_cb_l = new ui.Form.CheckboxGroup(
						{
							control: true,
							inline: 3,
							value:
								[
									this.m_Object.heating.features.gas ? 'object.heating.features.gas' : '',
									this.m_Object.heating.features.oil ? 'object.heating.features.oil' : '',
									this.m_Object.heating.features.electricity ? 'object.heating.features.electricity' : '',
									this.m_Object.heating.features.pellet ? 'object.heating.features.pellet' : '',
									this.m_Object.heating.features.plant_oil ? 'object.heating.features.plant_oil' : '',
									this.m_Object.heating.features.geothermal_pump ? 'object.heating.features.geothermal_pump' : '',
									this.m_Object.heating.features.air_heat_exchanger ? 'object.heating.features.air_heat_exchanger' : '',
									this.m_Object.heating.features.coal ? 'object.heating.features.coal' : '',
									this.m_Object.heating.features.biomass ? 'object.heating.features.biomass' : '',
									this.m_Object.heating.features.radiation ? 'object.heating.features.radiation' : '',
									this.m_Object.heating.features.solar ? 'object.heating.features.solar' : '',
									this.m_Object.heating.features.district ? 'object.heating.features.district' : '',
									this.m_Object.heating.features.log_man ? 'object.heating.features.log_man' : '',
									this.m_Object.heating.features.log_auto ? 'object.heating.features.log_auto' : '',
									this.m_Object.heating.features.floor_heating ? 'object.heating.features.floor_heating' : '',
									this.m_Object.heating.features.heater ? 'object.heating.features.heater' : ''
								],
							name: 'object.heating.features',
							checkboxes:
								[
									{
										title: 'Gas',
										name: 'gas',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.gas = !this.m_Object.heating.features.gas}
											}
									},
									{
										title: 'Öl',
										name: 'oil',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.oil = !this.m_Object.heating.features.oil}
											}
									},
									{
										title: 'Strom',
										name: 'electricity',
										descriptor:
											{
												on: {
													change: () => this.m_Object.heating.features.electricity = !this.m_Object.heating.features.electricity
												}
											}
									},
									{
										title: 'Pellet',
										name: 'pellet',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.pellet = !this.m_Object.heating.features.pellet}
											}
									},
									{
										title: 'Pflanzenöl',
										name: 'plant_oil',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.plant_oil = !this.m_Object.heating.features.plant_oil}
											}
									},
									{
										title: 'Erdwärmepumpe',
										name: 'geothermal_pump',
										descriptor:
											{
												on:
													{
														change: () => {
															this.m_Object.heating.features.geothermal_pump = !this.m_Object.heating.features.geothermal_pump;
														}
													}
											}
									},
									{
										title: 'Luftwärmetauscher',
										name: 'air_heat_exchanger',
										descriptor:
											{
												on:
													{
														change: () => {
															this.m_Object.heating.features.air_heat_exchanger = !this.m_Object.heating.features.air_heat_exchanger;
														}
													}
											}
									},
									{
										title: 'Kohle',
										name: 'coal',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.coal = !this.m_Object.heating.features.coal}
											}
									},
									{
										title: 'Biomasse',
										name: 'biomass',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.biomass = !this.m_Object.heating.features.biomass}
											}
									},
									{
										title: 'Strahlungsheizung',
										name: 'radiation',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.radiation = !this.m_Object.heating.features.radiation}
											}
									},
									{
										title: 'Solarunterstützt',
										name: 'solar',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.solar = !this.m_Object.heating.features.solar}
											}
									},
									{
										title: 'Fernwärme',
										name: 'district',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.district = !this.m_Object.heating.features.district}
											}
									},
									{
										title: 'Holzscheit (manuell)',
										name: 'log_man',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.log_man = !this.m_Object.heating.features.log_man}
											}
									},
									{
										title: 'Holzscheit (automatisch)',
										name: 'log_auto',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.log_auto = !this.m_Object.heating.features.log_auto}
											}
									},
									{
										title: 'Fußbodenheizung',
										name: 'floor_heating',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.floor_heating = !this.m_Object.heating.features.floor_heating}
											}
									},
									{
										title: 'Heizkörper',
										name: 'heater',
										descriptor:
											{
												on: {change: () => this.m_Object.heating.features.heater = !this.m_Object.heating.features.heater}
											}
									}
								]
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12 col-md-9')
							.appendTo(fg),
						this.m_Form,
						h_cb_l
					);
				}

				private buildDetails(_root: ui.base.BaseHTMLElement, _featuresRoot: ui.base.BaseHTMLElement): void {
					switch (this.m_Object.type ? this.m_Object.type.type : '') {
						case 'EFH':
						case 'ZFH':
						case 'DHH':
						case 'REH':
						case 'RMH':
							this.buildCommonDetails(_root);

							this.buildFeatures(_featuresRoot.empty());
							return;

						case 'MFH':
							this.buildMFHDetails(_root);

							this.buildFeatures(_featuresRoot.empty());
							return;

						default:
							return;
					}
				}

				private buildCommonDetails(_root: ui.base.BaseHTMLElement): void {
					_root.empty();

					// #region NHK
					const nhkPic = new ui.base.BaseHTMLElement('img');
					const nhkTyp = new ui.base.BaseHTMLElement('p').addClass('text-muted');
					this.NHKPic(nhkPic, nhkTyp);
					// #endregion NHK

					const col = new ui.base.BaseHTMLElement('div')
						.addClass('col-xs-12 col-md-9')
						.append(
							new ui.base.BaseHTMLElement('h4')
								.text('Objektspezifizierung')
								.addClass('text-muted')
						)
						.appendTo(_root);
					// #region ROOF
					{
						const selectionRoof = new ui.Form.RadioGroup(
							{
								name: 'object.type.roof',
								control: true,
								required: true,
								value: (this.m_Object.type as IEFH).roof,
								inline: 3,
								on:
									{
										change: () => {
											// @ts-ignore
											(this.m_Object.type as IEFH).roof = selectionRoof.val() || 'empty';

											this.NHKPic(nhkPic, nhkTyp);
										}
									},
								radioButtons:
									[
										{
											value: 'full',
											title: 'voll ausgebaut'
										},
										{
											value: 'empty',
											title: 'nicht ausgebaut'
										},
										{
											value: 'flat',
											title: 'Flachdach'
										}
									]
							}
						);

						this.addToForm(
							new ui.base.BaseHTMLElement('div')
								.addClass('col-xs-8')
								.appendTo(
									new ui.base.BaseHTMLElement('div')
										.addClass('form-group clearfix')
										.append(
											new ui.base.BaseHTMLElement('label')
												.addClass('control-label col-xs-4')
												.text('Dach')
										)
										.appendTo(col)
								),
							this.m_Form,
							selectionRoof
						);
					}
					// #endregion ROOF

					// #region CELLAR
					{
						const sliderCellar = new ui.Form.LabelledNumberSlider(
							(this.m_Object.type as IEFH).cellar || -1,
							{
								min: 1,
								step: 5,
								max: 100,
								name: 'object.type.cellar',
								control: true,
								required: false,
								sentinal: 'Nicht unterkellert',
								on:
									{
										change: () => {
											(this.m_Object.type as IEFH).cellar = sliderCellar.val() || 0;

											this.NHKPic(nhkPic, nhkTyp);
										}
									}
							},
							(value) => {
								if (value === 0) {
									return 'Nicht unterkellert';
								}

								if (value === 100) {
									return 'Voll unterkellert';
								}

								return value.toString().replace('.', ',') + '% unterkellert';
							}
						);

						this.addToForm(
							new ui.base.BaseHTMLElement('div')
								.addClass('col-xs-8')
								.appendTo(
									new ui.base.BaseHTMLElement('div')
										.addClass('form-group clearfix')
										.append(
											new ui.base.BaseHTMLElement('label')
												.addClass('control-label col-xs-4')
												.text('Unterkellerung')
										)
										.appendTo(col)
								),
							this.m_Form,
							sliderCellar
						);
					}
					// #endregion CELLAR

					// #region FLOOR
					{
						const sliderFloor = new ui.Form.LabelledNumberSlider(
							(this.m_Object.type as IEFH).floor || -1,
							{
								min: 1,
								step: 1,
								max: 3,
								name: 'object.type.floor',
								classes: ['iwv-req'],
								control: true,
								sentinal: 'Bitte wählen ...',
								required: true,
								on:
									{
										change: () => {
											(this.m_Object.type as IEFH).floor = sliderFloor.val() || null;

											this.NHKPic(nhkPic, nhkTyp);
										}
									}
							},
							(value) => value + " Vollgeschosse"
						);

						this.addToForm(
							new ui.base.BaseHTMLElement('div')
								.addClass('col-xs-8')
								.appendTo(
									new ui.base.BaseHTMLElement('div')
										.addClass('form-group clearfix')
										.append(
											new ui.base.BaseHTMLElement('label')
												.addClass('control-label col-xs-4')
												.text('Vollgeschosse ')
												.append(
													new ui.base.BaseHTMLElement('span')
														.addClass('fa fa-info-circle')
														.attr(
															'title',
															'Angabe der Vollgeschosse entspricht der Geschosszahl des Gebäudes ohne Dach- und Kellergeschoss.'
														)
												)
										)
										.appendTo(col)
								),
							this.m_Form,
							sliderFloor
						);
					}
					// #endregion FLOOR

					// #region NHKPIC
					new ui.base.BaseHTMLElement('div')
						.addClass('col-xs-12 col-md-3')
						.append(
							new ui.base.BaseHTMLElement('h4')
								.addClass('text-muted')
								.text('NHK2010 Schema')
						)
						.append(nhkPic)
						.append(nhkTyp)
						.appendTo(_root);
					// #endregion NHKPIC
				}

				private buildMFHDetails(_root: ui.base.BaseHTMLElement): void {
					_root.empty();

					const span: ui.Form.RadioGroup = new ui.Form.RadioGroup(
						{
							value: (this.m_Object.type as IMFH).span.toString(),
							name: 'object.type.span',
							on:
								{
									// @ts-ignore
									change: () => (this.m_Object.type as IMFH).span = span.val() || '1'
								},
							radioButtons:
								[
									{
										value: '1',
										title: 'Einspänner'
									},
									{
										value: '2',
										title: 'Zweispänner'
									},
									{
										value: '3',
										title: 'Dreispänner'
									},
									{
										value: '4',
										title: 'Vierspänner'
									}
								]
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12')
							.appendTo(
								new ui.base.BaseHTMLElement('div')
									.addClass('form-group clearfix')
									.appendTo(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-12 col-md-4')
											.append(
												new ui.base.BaseHTMLElement('h4')
													.addClass('text-muted')
													.text('Objektunterart')
											)
											.appendTo(_root)
									)
							),
						this.m_Form,
						span
					);

					const unit: ui.Form.RadioGroup = new ui.Form.RadioGroup(
						{
							value: (this.m_Object.type as IMFH).units,
							name: 'object.type.units',
							on:
								{
									change: () => {
										// @ts-ignore
										(this.m_Object.type as IMFH).units = unit.val() || '-_6';
									}
								},
							radioButtons:
								[
									{
										value: '-_6',
										title: 'Bis 6 Wohneinheiten'
									},
									{
										value: '7_-_20',
										title: '7 - 20 Wohneinheiten'
									},
									{
										value: '21_-',
										title: 'Mehr als 20 Wohneinheiten'
									}
								]
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12')
							.appendTo(
								new ui.base.BaseHTMLElement('div')
									.addClass('form-group clearfix')
									.appendTo(
										new ui.base.BaseHTMLElement('div')
											.addClass('col-xs-12 col-md-5')
											.append(
												new ui.base.BaseHTMLElement('h4')
													.addClass('text-muted')
													.text('Kapazität Wohneinheiten')
											)
											.appendTo(_root)
									)
							),
						this.m_Form,
						unit
					);

					new ui.base.BaseHTMLElement('img')
						.attr(
							{
								src: 'app/asset/brw/no_nhk_pic.png'
							}
						)
						.appendTo(
							new ui.base.BaseHTMLElement('div')
								.addClass('col-xs-12 col-md-3')
								.append(
									new ui.base.BaseHTMLElement('h4')
										.addClass('text-muted')
										.text('NHK2010 Schema')
								)
								.appendTo(_root)
						);
				}

				private buildFeatures(_root: ui.base.BaseHTMLElement): void {
					if (this.m_Object.type === null) {
						return;
					}

					new ui.base.BaseHTMLElement('h4')
						.addClass('text-muted')
						.text('Ausstattung')
						.appendTo(
							new ui.base.BaseHTMLElement('div')
								.addClass('col-xs-12')
								.appendTo(_root)
						);
					this.m_Object.type.features.overall = this.m_Object.type.features.overall == null ? 3 : this.m_Object.type.features.overall;
					if (this.m_Object.type.type !== 'ETW') {
						const toAll = new ui.Form.Select(
							{
								required: true,
								control: true,
								classes: ['iwv-req'],
								name: 'object.type.features.overall',
								// blank: ' -- Ausstattungsstufe wählen -- ',
								option:
									{
										1: 'Standardstufe 1',
										2: 'Standardstufe 2',
										3: 'Standardstufe 3',
										4: 'Standardstufe 4',
										5: 'Standardstufe 5'
									},
								on:
									{
										change: () => {
											if (!this.m_Object.type) {
												return;
											}

											const val = toAll.val();
											this.m_FeatureAll = toAll.val();

											Object.keys(this.m_Object.type.features).forEach((key) =>
											{
												// Don't redraw the section below, just set its values
												const input = _root.Root().find('input[name="object.type.features.' + key + '"]');
												if (input)
												{
													input.val([val]);
												}
												this.m_Object.type.features[key] = typeof val === 'string' && val !== '' ? parseInt(val, 10) : null;
											});
										}
									}
							}, this.m_Object.type.features.overall ? this.m_Object.type.features.overall.toString() : undefined
						)
							.rebuild(
								new ui.base.BaseHTMLElement('div')
									.addClass('col-xs-12 col-md-6')
									.appendTo(
										new ui.base.BaseHTMLElement('div')
											.addClass('form-group clearfix')
											.append(
												new ui.base.BaseHTMLElement('label')
													.text('Alle Ausstattungsstufen setzen auf ')
													.append(
														new ui.base.BaseHTMLElement('span')
															.addClass('fa fa-info-circle')
															.attr(
																'title',
																'Standardstufe: \n 1 : einfach \n 2: mittel \n 3: gehoben \n 4: stark gehoben \n 5: luxuriös'
															)
													)
													.addClass('control-label col-xs-12 col-md-6')
											)
											.appendTo(
												new ui.base.BaseHTMLElement('div')
													.addClass('col-xs-6')
													.appendTo(_root)
											)
									)
							);
						const row = new ui.base.BaseHTMLElement('div')
							.addClass('row')
							.appendTo(
								new ui.base.BaseHTMLElement('div')
									.addClass('col-xs-12')
									.appendTo(_root)
							);

						switch (this.m_Object.type.type) {
							case 'EFH':
								this.createSTDSTF(
									[
										{
											level: {
												1: new ui.base.BaseHTMLElement('p'),
												2: new ui.base.BaseHTMLElement('p'),
												3: new ui.base.BaseHTMLElement('p'),
												4: new ui.base.BaseHTMLElement('p'),
												5: new ui.base.BaseHTMLElement('p')
											},
											name: 'object.type.features.exterior_wall',
											title: 'Außenwände',
											classes: ['iwv-req'],
											value: this.m_Object.type.features.exterior_wall
										},
										{
											level: {
												1: new ui.base.BaseHTMLElement('p'),
												2: new ui.base.BaseHTMLElement('p'),
												3: new ui.base.BaseHTMLElement('p'),
												4: new ui.base.BaseHTMLElement('p'),
												5: new ui.base.BaseHTMLElement('p')
											},
											name: 'object.type.features.roof',
											title: 'Dach',
											value: this.m_Object.type.features.roof
										},
										{
											level: {
												1: new ui.base.BaseHTMLElement('p'),
												2: new ui.base.BaseHTMLElement('p'),
												3: new ui.base.BaseHTMLElement('p'),
												4: new ui.base.BaseHTMLElement('p'),
												5: new ui.base.BaseHTMLElement('p')
											},
											name: 'object.type.features.ceiling_stair',
											title: 'Deckenkonstruktion und Treppen',
											value: this.m_Object.type.features.ceiling_stair
										},
										{
											level: {
												1: new ui.base.BaseHTMLElement('p'),
												2: new ui.base.BaseHTMLElement('p'),
												3: new ui.base.BaseHTMLElement('p'),
												4: new ui.base.BaseHTMLElement('p'),
												5: new ui.base.BaseHTMLElement('p')
											},
											name: 'object.type.features.window_door_out',
											title: 'Fenster und Außentüren',
											value: this.m_Object.type.features.window_door_out
										},
										{
											level: {
												1: new ui.base.BaseHTMLElement('p'),
												2: new ui.base.BaseHTMLElement('p'),
												3: new ui.base.BaseHTMLElement('p'),
												4: new ui.base.BaseHTMLElement('p'),
												5: new ui.base.BaseHTMLElement('p')
											},
											name: 'object.type.features.floor',
											title: 'Fußböden',
											value: this.m_Object.type.features.floor
										},
										{
											level: {
												1: new ui.base.BaseHTMLElement('p'),
												2: new ui.base.BaseHTMLElement('p'),
												3: new ui.base.BaseHTMLElement('p'),
												4: new ui.base.BaseHTMLElement('p'),
												5: new ui.base.BaseHTMLElement('p')
											},
											name: 'object.type.features.heating',
											title: 'Heizung',
											value: this.m_Object.type.features.heating
										},
										{
											level: {
												1: new ui.base.BaseHTMLElement('p'),
												2: new ui.base.BaseHTMLElement('p'),
												3: new ui.base.BaseHTMLElement('p'),
												4: new ui.base.BaseHTMLElement('p'),
												5: new ui.base.BaseHTMLElement('p')
											},
											name: 'object.type.features.indoor_wall_door',
											title: 'Innenwände und -türen',
											value: this.m_Object.type.features.indoor_wall_door
										},
										{
											level: {
												1: new ui.base.BaseHTMLElement('p'),
												2: new ui.base.BaseHTMLElement('p'),
												3: new ui.base.BaseHTMLElement('p'),
												4: new ui.base.BaseHTMLElement('p'),
												5: new ui.base.BaseHTMLElement('p')
											},
											name: 'object.type.features.sanitary',
											title: 'Sanitäreinrichtungen',
											value: this.m_Object.type.features.sanitary
										},
										{
											level: {
												1: new ui.base.BaseHTMLElement('p'),
												2: new ui.base.BaseHTMLElement('p'),
												3: new ui.base.BaseHTMLElement('p'),
												4: new ui.base.BaseHTMLElement('p'),
												5: new ui.base.BaseHTMLElement('p')
											},
											name: 'object.type.features.additional',
											title: 'Sonstige technische Ausstattung',
											value: this.m_Object.type.features.additional
										}
									],
									row
								);
								break;
						}

					} else {
						this.addToForm(
							new ui.base.BaseHTMLElement('div')
								.addClass('col-xs-9')
								.appendTo(
									new ui.base.BaseHTMLElement('div')
										.addClass('form-group clearfix')
										.append(
											new ui.base.BaseHTMLElement('label')
												.text('Ausstattung der Eigentumswohnung')
												.addClass('control-label col-xs-3')
										)
										.appendTo(
											new ui.base.BaseHTMLElement('div')
												.addClass('col-xs-12')
												.appendTo(_root)
										)
								),
							this.m_Form,
							new ui.Form.RadioGroup(
								{
									control: true,
									required: true,
									name: 'object.type.features.overall',
									inline: 3,
									// @ts-ignore
									value: this.m_Object.type.features.overall,
									radioButtons:
										[
											{
												title: 'Einfach',
												value: '2'
											},
											{
												title: 'Mittel',
												value: '3'
											},
											{
												title: 'Gehoben',
												value: '4'
											}
										]
								}
							)
						);
					}
				}

				private createSTDSTF(levels: IEquipment[], _root: ui.base.BaseHTMLElement): void {
					// const group = new ui.base.BaseHTMLElement('ul')
					// 	.addClass('list-group')
					// 	.appendTo(
					// 		new ui.base.BaseHTMLElement('div')
					// 			.addClass('col-xs-12')
					// 			.appendTo(
					// 				new ui.base.BaseHTMLElement('div')
					// 					.addClass('form-group clearfix')
					// 					.appendTo(
					// 						new ui.base.BaseHTMLElement('div')
					// 							.addClass('col-xs-6')
					// 							.appendTo(
					// 								_root
					// 							)
					// 					)
					// 			)
					// 	);

					const stdstf = new ui.base.BaseHTMLElement('div')
						.addClass('col-xs-12')
						.append(
							new ui.base.BaseHTMLElement('h5')
								.text('Erläuterungen zur Standardstufe')
								.addClass('text-muted')
						)
						.appendTo(_root);

					//#region ACC_EXAMPLE
					// # <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
					// # 	<div class="panel panel-default">
					// # 		<div class="panel-heading" role="tab" id="headingOne">
					// # 			<h4 class="panel-title">
					// # 				<a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
					// # 					Collapsible Group Item #1
					// # 				</a>
					// # 			</h4>
					// # 		</div>
					// # 		<div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
					// # 			<div class="panel-body">
					// # 				Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
					// # 			</div>
					// # 		</div>
					// # 	</div>
					// # 	<div class="panel panel-default">
					// # 		<div class="panel-heading" role="tab" id="headingTwo">
					// # 			<h4 class="panel-title">
					// # 				<a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
					// # 					Collapsible Group Item #2
					// # 				</a>
					// # 			</h4>
					// # 		</div>
					// # 		<div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
					// # 			<div class="panel-body">
					// # 				Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
					// # 			</div>
					// # 		</div>
					// # 	</div>
					// # 	<div class="panel panel-default">
					// # 		<div class="panel-heading" role="tab" id="headingThree">
					// # 			<h4 class="panel-title">
					// # 				<a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
					// # 					Collapsible Group Item #3
					// # 				</a>
					// # 			</h4>
					// # 		</div>
					// # 		<div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
					// # 			<div class="panel-body">
					// # 				Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
					// # 			</div>
					// # 		</div>
					// # 	</div>
					// # </div>
					//#endregion ACC_EXAMPLE

					const acc = new AccordionField(
						{
							id: 'cb86105e-25b1-4429-809c-bbd9500dec2b'
						}
					);

					new ui.base.BaseHTMLElement('div')
						.addClass('col-xs-12')
						.appendTo(
							new ui.base.BaseHTMLElement('div')
								.addClass('form-group clearfix')
								.appendTo(
									new ui.base.BaseHTMLElement('div')
										.addClass('col-xs-6')
										.appendTo(
											_root
										)
								)
						).append(
						$(acc.getElement())
					);

					levels.forEach(
						(level) => {
							const lvl: ui.Form.ICheckableLabel[] = [];

							Object.keys(level.level).forEach(
								(key) => {
									lvl.push(
										{
											title: 'Standardstufe ' + key,
											value: key
										}
									);
								}
							);

							const holder = new ui.base.BaseHTMLElement('div');

							new ui.Form.RadioGroup(
								{
									name: level.name,
									classes: level.classes,
									control: true,
									radioButtons: lvl,
									value: level.value === null ? null : level.value.toString(),
									css:
										{
											'padding-left': '20px'
										}
								}
							).rebuild(holder);

							acc.addPanel(
								{
									id: ui.utils.UUID.Gen(),
									header: level.title,
									body: [holder.Root()[0]]
								}
							);
						}
					);
				}

				private NHKPic(pic: ui.base.BaseHTMLElement, text: ui.base.BaseHTMLElement): void {
					let floor;
					let cellar;
					let roof;
					let nhk: number | null = null;
					let nhk_zusatz = ' ';

					switch (this.m_Object.type ? this.m_Object.type.type : '') {
						case 'EFH':
						case 'ZFH':
							roof = 0.01;
							cellar = 0.2;
							floor = 0.1;
							switch ((this.m_Object.type as IEFH).roof) {
								case 'flat':
									roof = 0.03;
									break;
								case 'empty':
									roof = 0.02;
									break;
							}

							if ((this.m_Object.type as IEFH).cellar !== null) {
								cellar = 0.0;
							}

							if ((this.m_Object.type as IEFH).floor === null) {
								break;
							} else if ((this.m_Object.type as IEFH).floor === 1) {
								floor = 0.0;
							}
							// @ts-ignore
							else if ((this.m_Object.type as IEFH).floor > 2) {
								nhk_zusatz += '(Vergleichbar zu 2 Vollgeschossen)';
							}

							nhk = 1.0 + roof + cellar + floor;
							break;

						case 'DHH':
						case 'REH':
							roof = 0.01;
							cellar = 0.2;
							floor = 0.1;
							switch ((this.m_Object.type as IREH).roof) {
								case 'flat':
									roof = 0.03;
									break;
								case 'empty':
									roof = 0.02;
									break;
							}

							if ((this.m_Object.type as IREH).cellar !== null) {
								cellar = 0.0;
							}

							if ((this.m_Object.type as IREH).floor === null) {
								break;
							} else if ((this.m_Object.type as IREH).floor === 1) {
								floor = 0.0;
							}
							// @ts-ignore
							else if ((this.m_Object.type as IEFH).floor > 2) {
								nhk_zusatz += '(Vergleichbar zu 2 Vollgeschossen)';
							}

							nhk = 2.0 + roof + cellar + floor;
							break;

						case 'RMH':
							if ((this.m_Object.type as IRMH).floor === 0) {
								break;
							}

							roof = 0.01;
							cellar = 0.2;
							floor = 0.1;
							switch ((this.m_Object.type as IRMH).roof) {
								case 'flat':
									roof = 0.03;
									break;
								case 'empty':
									roof = 0.02;
									break;
							}

							if ((this.m_Object.type as IRMH).cellar !== null) {
								cellar = 0.0;
							}

							if ((this.m_Object.type as IRMH).floor === null) {
								break;
							} else if ((this.m_Object.type as IRMH).floor === 1) {
								floor = 0.0;
							}
							// @ts-ignore
							else if ((this.m_Object.type as IEFH).floor > 2) {
								nhk_zusatz += '(Vergleichbar zu 2 Vollgeschossen)';
							}

							nhk = 3.0 + roof + cellar + floor;
							break;
					}

					if (nhk === null) {
						pic.attr(
							{
								src: 'app/asset/brw/no_nhk_pic.png'
							}
						);
						text.text(
							'Keine NHK Zuordnung möglich'
						);

						return;
					}

					pic.attr(
						{
							src: 'app/asset/brw/' + nhk.toFixed(2).toString().replace('.', '_') + '.png'
						}
					);
					text.text('NHK-Typ: ' + nhk.toFixed(2).toString() + nhk_zusatz);
				}
			}
		}
	}
}
